/**
 * Serge Header - Scroll behavior and transparency handling
 */
(function() {
  'use strict';

  const SCROLL_THRESHOLD = 100;
  const header = document.querySelector('.serge-header--transparent');

  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  function updateHeader() {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Add/remove scrolled class based on scroll position
    if (currentScroll > SCROLL_THRESHOLD) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    // Optional: Hide header on scroll down, show on scroll up
    // Uncomment if desired:
    /*
    if (currentScroll > lastScroll && currentScroll > 200) {
      header.classList.add('header-hidden');
    } else {
      header.classList.remove('header-hidden');
    }
    */

    lastScroll = currentScroll;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  // Initial check
  updateHeader();

  // Listen for scroll
  window.addEventListener('scroll', onScroll, { passive: true });

  // Re-check on resize (viewport height changes)
  window.addEventListener('resize', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();
